"use strict";
/**
 * Angular helpers.
 *
 * @packageDocumentation
 * @module AngularHelpers
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a pixel width of the given text.
 */
exports.getTextWidth = function (text, fontSize, fontFamily) {
    if (text == null || fontSize == null || fontFamily == null) {
        return null;
    }
    var element = document.createElement('canvas');
    var elContex = element.getContext('2d');
    if (elContex != null) {
        elContex.font = '' + fontSize + ' ' + fontFamily + '';
        return elContex.measureText(text).width;
    }
    return null;
};
//# sourceMappingURL=template.js.map